<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m12 2c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9l11.21 11.21c-1.35 1.06-3.05 1.69-4.9 1.69zm6.31-3.1-11.21-11.21c1.35-1.06 3.05-1.69 4.9-1.69 4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
    />
  </svg>
</template>
